import { render, staticRenderFns } from "./tanitimMail.vue?vue&type=template&id=69562c9e"
import script from "./tanitimMail.vue?vue&type=script&lang=js"
export * from "./tanitimMail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports